import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { blurLocationSearch } from '../../../../actions/locationActions';
import BrandPageHero from '../../../../components/BrandPageHero';
import LocationSearchContainer from '../../../../containers/LocationSearchContainer';
import Header from '../../../../containers/Header';

const LOCATION_SEARCH_ID = 'location-search-id';

class BrandHero extends Component {
  render() {
    const {
      isLocationSearchFocused,
      brand,
      brandName,
      searchCaption,
      tags,
      ...otherProps
    } = this.props;

    const headerComponent = <Header isTransparent logoColor="white" />;
    const locationSearch = (
      <div id={LOCATION_SEARCH_ID}>
        <LocationSearchContainer
          caption={searchCaption}
          searchType="brand"
          brand={brand}
          brandName={brandName}
          trackingPage="Brand Landing Page"
          hasInputFocus={isLocationSearchFocused}
          onBlurSearch={this.props.blurLocationSearch}
        />
      </div>
    );

    return (
      <BrandPageHero
        headerComponent={headerComponent}
        locationSearchComponent={locationSearch}
        tags={tags.split(',').map((tag) => tag.trim())}
        {...otherProps}
      />
    );
  }
}

BrandHero.propTypes = {
  // props from Redux
  isLocationSearchFocused: PropTypes.bool.isRequired,
  blurLocationSearch: PropTypes.func.isRequired,

  // props from Storyblok
  brand: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  searchCaption: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
  ratingDescription: PropTypes.string.isRequired,
  ratingCount: PropTypes.string.isRequired,
  tags: PropTypes.string.isRequired,
  themeColor: PropTypes.string,
  description: PropTypes.string.isRequired,
};

BrandHero.defaultProps = {
  themeColor: '#00CCBC',
};

const mapStateToProps = (state) => {
  const { focused } = state.location.search;
  return { isLocationSearchFocused: focused };
};

const mapDispatchToProps = (dispatch) => ({
  blurLocationSearch: () => dispatch(blurLocationSearch()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrandHero);
